import { AxiosResponse } from 'axios'
import { useMutation, useQuery } from '@tanstack/react-query'
import { httpClient, ROOT_URL } from '../App'

export interface IConfigFee {
  id: number
  serviceFeeType: any
  version: any
  serviceFeeFixedCrypto: any
  serviceFeeFixedFiat: any
  serviceFeePercentCrypto: number
  serviceFeePercentFiat: number
  cryptoTransferFeeType: string
  cryptoTransferFeeFixed: any
  cryptoTransferFeePercent: number
  fiatTransferFeeType: string
  fiatTransferFeeFixed: number
  fiatTransferFeePercent: any
  createdAt: string
  updatedAt: string

  exchangeMoneyFeeType: any
  exchangeMoneyFeeFixedCrypto: any
  exchangeMoneyFeeFixedFiat: any
  exchangeMoneyFeePercentCrypto: number
  exchangeMoneyFeePercentFiat: number
}

export const useConfigFee = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: configFee,
  })
}

export function configFee(body: any): Promise<AxiosResponse<any>> {
  return httpClient.post(`${ROOT_URL}/api/v1/fee-configuration`, body)
}

export const useGetConfigFee = () => {
  return useQuery<{ data: { data: IConfigFee } }>(
    [`/api/v1/fee-configuration`],
    async () => getConfigFee()
  )
}

export function getConfigFee(): Promise<AxiosResponse<any>> {
  return httpClient.get(`${ROOT_URL}/api/v1/fee-configuration`)
}
